var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInconsistency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.17 58.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#134fc8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.8,0H4.36A4.36,4.36,0,0,0,0,4.36V46.77a4.37,4.37,0,0,0,4.36,4.37H28.23l-1.09,5.33H22.38a1.2,1.2,0,1,0,0,2.39H51.79a1.2,1.2,0,0,0,0-2.39H47l-1.09-5.33H69.8a4.37,4.37,0,0,0,4.37-4.37V4.36A4.37,4.37,0,0,0,69.8,0ZM44.59,56.47h-15l1.09-5.33H43.49Zm27.18-9.7a2,2,0,0,1-2,2H4.36a2,2,0,0,1-2-2v-3H71.77Zm0-5.42H2.39v-37a2,2,0,0,1,2-2H69.8a2,2,0,0,1,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.15,47.44H38a1.2,1.2,0,1,0,0-2.39H36.15a1.2,1.2,0,0,0,0,2.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.3 21.16 36.01 25.48 38.15 25.48 38.87 21.16 39.22 12.79 34.94 12.79 35.3 21.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.3,
    y: 27.58,
    width: 3.57,
    height: 3.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.08,7.69A14.18,14.18,0,1,0,51.26,21.87,14.18,14.18,0,0,0,37.08,7.69Zm0,26.08A11.9,11.9,0,1,1,49,21.87,11.92,11.92,0,0,1,37.08,33.77Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInconsistency);
export default __webpack_public_path__ + "static/media/inconsistency.b821d60a2ff863af034dc094c3caca81.svg";
export { ForwardRef as ReactComponent };